import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { StateToAccentColorMap, StateToTextColorMap } from 'dashboard/constants/visuals-dashboard/state-to-colors-maps';
import { IceDashboardDisplayStateEnum } from 'dashboard/enums/visuals/ice-dashboard-display-state.enum';
import { VisualsDashboardRangesColorEnum, VisualsDashboardTextColorEnum } from 'dashboard/enums/visuals/visuals-dashboard-colors.enum';

export interface TableColumn {
    key: string;
    translationKey: string;
    width?: string;
}

interface ComputedRow {
    cells: { key: string; value: string; width?: string }[];
}

interface StateConfig {
    accent: VisualsDashboardRangesColorEnum;
    text: VisualsDashboardTextColorEnum;
}

@Component({
    selector: 'app-ice-visuals-dashboard-table-display',
    imports: [TranslateModule],
    templateUrl: './ice-visuals-dashboard-table-display.component.html',
    styleUrl: './ice-visuals-dashboard-table-display.component.scss',
})
export class IceVisualsDashboardTableDisplayComponent {
    columns = input.required<TableColumn[]>();
    data = input.required<Record<string, any>[]>();
    loading = input.required<boolean>();
    isEmpty = input<boolean>(false);
    state = input<IceDashboardDisplayStateEnum | null>(IceDashboardDisplayStateEnum.NEUTRAL);
    maxRows = input<number>(8);
    totalRows = input.required<number>();
    totalItemsTranslationKey = input<string>('dashboard.visuals.components.table.totalItems.default');
    emptyMessageTranslationKey = input<string>('dashboard.visuals.components.table.noData.default');
    icon = input<string | null>(null);
    emptyStateIcon = input<string | null>(null);

    skeletonRows = [1, 2, 3, 4, 5];

    displayedRows = computed<ComputedRow[]>(() => {
        const allData = this.data();
        const cols = this.columns();
        const max = this.maxRows();

        return allData.slice(0, max).map((row) => ({
            cells: cols.map((col) => ({
                key: col.key,
                value: row[col.key] != null ? String(row[col.key]) : '',
                width: col.width,
            })),
        }));
    });

    stateConfig = computed<StateConfig>(() => {
        let state = this.state();
        if (!state) {
            state = IceDashboardDisplayStateEnum.NEUTRAL;
        }
        return {
            accent: StateToAccentColorMap[state],
            text: StateToTextColorMap[state],
        };
    });
}
